<div class="py-5 px-8 min-h-content bg-white">
  <h1 class="font-semibold text-6">{{ translatePrefix + 'report' | translate }}</h1>

  <p-selectButton
    styleClass="my-4"
    [options]="tabOptions"
    [allowEmpty]="false"
    [(ngModel)]="tabActive"
    optionValue="value">
    <ng-template pTemplate="item" let-item>
      <div>
        {{ translatePrefix + item.title | translate }}
      </div>
    </ng-template>
  </p-selectButton>

  <div class="flex flex-col gap-6">
    @switch (tabActive) {
      <!-- PRODUCT -->
      @case (ReportTabEnum.PRODUCT) {
        <app-production-details-selection
          [(isRunning)]="isRunningProductDetailsReport"
          [(params)]="productDetailsReportParams"
          [commissionTeams]="commissionTeams"
          [companies]="companies"
          [productTypes]="productTypes"
          [products]="products"
          [sources]="sources"
          [policyStatuses]="policyStatuses"></app-production-details-selection>

        <app-product-details-report
          [(isRunning)]="isRunningProductDetailsReport"
          [params]="productDetailsReportParams"></app-product-details-report>
      }

      <!-- PERFORMANCE -->
      @case (ReportTabEnum.PERFORMANCE) {
        <app-performance-selection
          [title]="translatePrefix + 'report-performance' | translate"
          [isPerformance]="true"
          [(params)]="performanceReportParams"
          [(isRunning)]="isRunningPerformanceReport"
          [userGroups]="userGroups"
          [isLoading]="isLoading"></app-performance-selection>

        <app-performance-report
          [params]="performanceReportParams"
          [(isRunning)]="isRunningPerformanceReport"></app-performance-report>
      }

      <!-- LEAD -->
      @case (ReportTabEnum.LEAD) {
        <app-performance-selection
          [title]="translatePrefix + 'report-lead' | translate"
          [isPerformance]="false"
          [(params)]="leadReportParams"
          [(isRunning)]="isRunningLeadReport"
          [userGroups]="userGroups"
          [isLoading]="isLoading"></app-performance-selection>

        <app-lead-report [params]="leadReportParams" [(isRunning)]="isRunningLeadReport"></app-lead-report>
      }

      <!-- NOTE -->
      @case (ReportTabEnum.NOTE) {
        <app-note-selection
          [title]="translatePrefix + 'report-note' | translate"
          [(params)]="noteReportParams"
          [(isRunning)]="isRunningNoteReport"
          [userGroups]="userGroups"
          [isLoading]="isLoading"></app-note-selection>

        <app-note-report [params]="noteReportParams" [(isRunning)]="isRunningNoteReport"></app-note-report>
      }
    }
  </div>
</div>
